import { css } from '@emotion/css';

export const appBar = css`
  &.MuiPaper-root {
    background: var(--colors-primary-30);
    box-shadow: none;
    width: 100%;
    max-width: 550px;
    transform: translateX(-50%);
    left: 50%;
  }
`;

export const toolbar = css`
  &.MuiToolbar-root {
    height: var(--header-height);
    min-height: unset;
  }
`;

export const backButtonHeader = (bgColor: string) => css`
  top: 0;
  width: 100%;
  height: 56px;
  gap: 0.75rem;
  color: white;
  display: flex;
  padding: 1rem;
  position: fixed;
  max-width: 550px;
  align-items: center;
  background-color: var(${bgColor});

  img {
    cursor: pointer;
  }
`;
